import useApiCallService from "../../Common/Helpers/ApiCall";
import { CheckUserPermission } from "../../AppSystem/Helpers/CheckUserPermission";
import React, {useEffect, useState} from "react";
import {Button, Col, Row} from "reactstrap";
import {ChangeDateFormat} from "../../Common/Helpers/ChangeDateFormat";
import {CustomButton} from "../../Common/Components/Button/CustomButton";
import {ADMIN_PATHS} from "../../config";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {CheckUserRole} from "../../AppSystem/Helpers/CheckUserRole";
import { OrgUsersList } from "./OrgUsersList";
import { FlashMessage } from "../../Common/Helpers/FlashMessage";
import { CustomReload } from "../../AppSystem/Helpers/CustomReload";
import { useHeader } from "../../Auth/Components/Nav/HeaderContext";
import { CheckMobile } from "../../AppSystem/Helpers/CheckMobile";
import { useSelector } from "react-redux";

export function AdminOrganizationInfo() {
    const { rolesData } = useSelector(state => state.auth);
    const isSuperAdmin = CheckUserRole(rolesData, "SuperAdmin");
    let permissionUpdateOrg = false;
    if (CheckUserPermission("system") || CheckUserPermission("system.org") || CheckUserPermission("system.org.update")) {
        permissionUpdateOrg = true;
    }
    const { t } = useTranslation()
    const { ApiCall } = useApiCallService();
    const [apiResponseOrgInfo, setApiResponseOrgInfo] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);

    const idValue = new URLSearchParams(window.location.search).get('id');
    const navigate = useNavigate();
    const isMobile = CheckMobile(998);
    const { setPageTitle, setPageTitleKey, setOnBack } = useHeader();

    useEffect(() => {
        setPageTitle(t('adminLabel.details'));
        setPageTitleKey('adminLabel.details');
        setOnBack(() => navigate(ADMIN_PATHS.ADMIN_ORGANIZATION));
        return () => { setPageTitle(''); setPageTitleKey(''); setOnBack(null); };
    }, [t]);

    useEffect(() => {

        const handleApiResponseGetOrgUser  = (apiResponseOrgInfo) => {
            setApiResponseOrgInfo(apiResponseOrgInfo);

        };
        const GetOrgUser = async () => {
            try {
                const apiCallOptions = {
                    method: "get",
                    url: `/org/admin?id=${idValue}`,
                };

                await ApiCall(apiCallOptions, handleApiResponseGetOrgUser );

            } catch (error) {
                console.log('error', error);
            }
        };

        GetOrgUser();

    }, []);

    const updateOrgCronjob = async () => {
        try {
            FlashMessage('Uppgradering av organisationer', 'flash-messageSuccess');
    
            const apiCallOptions = {
                method: "post",
                url: `/roten/update-org-cronjob?orgId=${idValue || ''}&fromOrgInfo=true`,
            };
    
            await ApiCall(apiCallOptions, 
                (response) => {
                    FlashMessage('Organisationen har uppdaterats', 'flash-messageSuccess');
                    setTimeout(()=>{
                        CustomReload();
                    },2000);
                }, 
                (error) => {
                    console.error(error);
                    setErrorMessage('Det uppstod ett problem, försök igen senare.');
                    FlashMessage('Det uppstod ett problem, försök igen senare.', 'flash-messageError');
                }
            );
        } catch (err) {
            console.error(err);
            setErrorMessage('Ett oväntat fel inträffade.');
            FlashMessage('Ett oväntat fel inträffade.', 'flash-messageError');
        }
    };

    return(
        <>
            {!isMobile && (
                <Col lg={12} className="px-0">
                    <CustomButton
                        text={t('button.back')}
                        icon={'bx bx-chevron-left'}
                        buttonSize={'small'}
                        customClasses={'m-3 rounded'}
                        onClick={() => {
                            navigate(ADMIN_PATHS.ADMIN_ORGANIZATION)
                        }}
                    />
                </Col>
            )}
            {apiResponseOrgInfo !== null ?
                <Col lg="12" className='card card-backend p-4 mb-3'>
                    <Row className="d-flex align-items-center justify-content-between">
                        <Col>
                            <h2 className="rokkitt-font">{t('adminLabel.details')}</h2>
                        </Col>
                        {permissionUpdateOrg && (
                            <Col className="p-0 d-flex justify-content-end">
                                <Button
                                    className="bg-green"
                                    onClick={updateOrgCronjob}
                                    style={{ minWidth: "210px", whiteSpace: "nowrap" }}
                                >
                                    {t('orgCronjob.updateSelected')}
                                </Button>
                            </Col>
                        )}
                    </Row>
                    <ul className="list-unstyled">
                        {isSuperAdmin === true ?
                            <li className="pt-2 row">
                                <span className="fw-bold col-6 col-lg-1">{t('modelLabel.id')}:</span>
                                <span className=" col-6 col-lg-11">{apiResponseOrgInfo.id}</span>
                            </li>
                            : ''}
                        {apiResponseOrgInfo.visualId !== "" ?
                            <li className="pt-2 row">
                                <span className="fw-bold col-6 col-lg-1">{t('modelLabel.id')}:</span>
                                <span className="col-6 col-lg-11">{apiResponseOrgInfo.visualId}</span>
                            </li>
                            : ""}
                        <li className="pt-2 row">
                            <span className="fw-bold col-6 col-lg-1">{t('modelLabel.name')}:</span>
                            <span className="col-6 col-lg-11">{apiResponseOrgInfo.name}</span>
                        </li>
                        {apiResponseOrgInfo.parentId !== undefined ?
                            <>
                                {isSuperAdmin === true ?
                                    <li className="pt-2 row">
                                        <span className="fw-bold col-6 col-lg-1">{t('modelLabel.parentId')}:</span>
                                        <span className="col-6 col-lg-11">{apiResponseOrgInfo.parentId}</span>
                                    </li>
                                    : ''}
                                <li className="pt-2 row">
                                    <span className="fw-bold col-6 col-lg-1">{t('modelLabel.parentName')}:</span>
                                    <span className="col-6 col-lg-11">{apiResponseOrgInfo.parentName}</span>
                                </li>
                            </>
                            : ''}
                        <li className="pt-2 row">
                            <span className="fw-bold col-6 col-lg-1">{t('modelLabel.type')}:</span>
                            <span className="col-6 col-lg-11">{apiResponseOrgInfo.type}</span>
                        </li>
                        <li className="pt-2 row">
                            <span className="fw-bold col-6 col-lg-1">{t('modelLabel.createdAt')}:</span>
                            <span className="col-6 col-lg-11">{ChangeDateFormat('dateTime', apiResponseOrgInfo.createdAt)}</span>
                        </li>
                    </ul>
                </Col>
                : ''}
                <OrgUsersList organizationId={idValue}/>
        </>);

}